import React from 'react';
import PropTypes from 'prop-types';

import ClearIcon from '@mui/icons-material/Clear';
import { Tooltip } from '@mui/material';

import classes from './iconStyles.module.css';

const OnExitIcon = ({ onClick, title = 'Close', customClass = '' }) => {
    return (
        <Tooltip title={title} placement={'top'}>
            <div className={`${classes.exitIcon} ${classes[customClass]}`} onClick={onClick}>
                <ClearIcon aria-label="exit-icon" />
            </div>
        </Tooltip>
    );
};

OnExitIcon.propTypes = {
    onClick: PropTypes.func,
    title: PropTypes.string,
    customClass: PropTypes.string
};

export default OnExitIcon;
